export default __webpack_public_path__ + "58ee83377b8769f9561052fc617a35ef.svg";